import { gql } from '@apollo/client';

export const SECTION = gql`
  query Section($lng: String, $id: Float) {
    section(lng: $lng, id: $id) {
      section {
        id
        name
        articles {
          articles {
            body
            id
            title
          }
        }
      }
    }
  }
`;
